export const toSelectValue = (value) => {
  const isEmptyValue = value === undefined || value === null;
  return !isEmptyValue ? (Array.isArray(value) ? [...value] : [value]) : [];
};
